import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Header from "../components/Header";
import Breadcrumbs from "../components/Breadcrumbs";
import Footer from "../components/Footer";
import { useTranslation } from "react-i18next";
import AnimatedText from "../components/AnimatedText";
import Seo from "../components/Seo";
import axios from "axios";
import { toast } from "react-toastify";

const Support = () => {
  const { t, i18n } = useTranslation();
  const { pathname } = useLocation();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  // useEffect(() => {
  //   const currentLang = i18n.language;
  //   const direction = currentLang === "ar" ? "rtl" : "ltr";
  //   document.documentElement.setAttribute("dir", direction);
  //   document.documentElement.setAttribute("lang", currentLang);
  // }, [i18n.language]);

  return (
    <>
      <Seo
        title="Support — Legal Platform"
        description="Get help with accounts, payments, technical issues, and platform usage. Our team ensures a smooth, secure experience."
        canonicalPath="/support"
        image="/favicon.png"
      />
      <div className="privacy-bg from-top">
        <Header />
      </div>
      <Breadcrumbs />

      <div className="container mt-5">
        <div className="row justify-content-center">
          <div className="col-12">
            <div
              className="info-page-main-card mb-4"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              <h1 className="home-hero-title text-center"><AnimatedText text="Support" /></h1>
              <div className="home-hero-text text-center">
                <AnimatedText text="Our support team is available to assist you with any questions regarding your account, payments, technical issues, or platform usage. Whether you are a user, lawyer, or corporate client, we are committed to ensuring a smooth and secure experience on LegalPlatform." />
                <br /> <br />
                <AnimatedText text="If you require assistance, you can contact our team directly through the platform or via our official support channels. We aim to respond promptly and resolve inquiries efficiently." />
              </div>
            </div>
          </div>

          <div className="d-flex justify-content-center mt-5">
            <div style={{ width: "100%", maxWidth: "500px" }}>
              <h5 className="fw-bold mb-4">
                Get instant help from our experienced support team
              </h5>
              <form
                onSubmit={async (e) => {
                  e.preventDefault();
                  if (!name.trim() || !email.trim() || !phone.trim() || !message.trim()) {
                    toast.error("Please fill all fields.");
                    return;
                  }
                  const emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
                  if (!emailOk) {
                    toast.error("Please enter a valid email.");
                    return;
                  }
                  setLoading(true);
                  try {
                    const cleaned = phone.replace(/[^\d+]/g, "");
                    let phoneCode = "";
                    let phoneNumber = cleaned;
                    if (cleaned.startsWith("+")) {
                      const digits = cleaned.slice(1).replace(/\D/g, "");
                      if (digits.length > 9) {
                        phoneCode = digits.slice(0, digits.length - 9);
                        phoneNumber = digits.slice(-9);
                      } else {
                        phoneNumber = digits;
                      }
                    } else {
                      const digits = cleaned.replace(/\D/g, "");
                      phoneNumber = digits;
                    }
                    const url = `${process.env.REACT_APP_API_URL}/contact-us`;
                    const payload = {
                      name,
                      email,
                      phoneCode,
                      phone: phoneNumber,
                      message,
                    };
                    const res = await axios.post(url, payload);
                    if (res?.data?.status) {
                      toast.success(res?.data?.message || "Thank you for contacting us.");
                      setName("");
                      setEmail("");
                      setPhone("");
                      setMessage("");
                    } else {
                      toast.error(res?.data?.message || "Something went wrong.");
                    }
                  } catch (err) {
                    toast.error("Unable to submit your request. Please try again.");
                  } finally {
                    setLoading(false);
                  }
                }}
              >
                <div className="mb-3">
                  <label className="form-label text-muted">
                    What is your name?
                  </label>
                  <input
                    type="text"
                    className="form-control support-control"
                    placeholder=""
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label text-muted">
                    What is your email?
                  </label>
                  <input
                    type="email"
                    className="form-control support-control"
                    placeholder=""
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label text-muted">
                    What is your contact number?
                  </label>
                  <input
                    type="tel"
                    className="form-control support-control"
                    placeholder=""
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                  />
                </div>

                <div className="mb-4">
                  <label className="form-label text-muted">
                    Tell us more about your issue?
                  </label>
                  <textarea
                    className="form-control support-control"
                    rows="4"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                  ></textarea>
                </div>

                <div className="text-center">
                  <button
                    type="submit"
                    className="btn fw-bold"
                    style={{
                      backgroundColor: "#000000",
                      color: "#ffffff",
                      borderRadius: "10px",
                      width: "120px",
                      marginBottom: "32px",
                    }}
                    disabled={loading}
                  >
                    {loading ? "Submitting..." : "Submit"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </>
  );
};

export default Support;
